import React from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { Calendar, Clock, ArrowUpRight } from "lucide-react";
import { blogPosts } from "../lib/content";

export default function Blog() {
  return (
    <>
      <PageHeader
        eyebrow="Bilgi Merkezi"
        title="Blog"
        description="Finans okuryazarlığınızı artıracak rehberler, analizler ve uzman içerikleri."
      />
      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {blogPosts.map((p) => (
              <Link
                key={p.slug}
                to={`/blog/${p.slug}`}
                className="group p-7 rounded-2xl bg-white border border-slate-200 hover:bg-slate-950 hover:border-slate-950 transition-all duration-300 block"
                data-testid={`blog-card-${p.slug}`}
              >
                <div className="flex items-center gap-3 mb-5">
                  <span className="px-2.5 py-1 rounded-md bg-brand-gold/15 text-brand-gold text-[10px] uppercase tracking-[0.2em] font-bold">
                    {p.cat}
                  </span>
                </div>
                <h3 className="font-display text-xl font-bold text-slate-950 group-hover:text-white mb-3 leading-tight transition-colors">
                  {p.title}
                </h3>
                <p className="text-sm text-slate-600 group-hover:text-slate-300 mb-6 leading-relaxed transition-colors">
                  {p.desc}
                </p>
                <div className="flex items-center justify-between text-xs text-slate-500 group-hover:text-slate-400 transition-colors">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1.5">
                      <Calendar className="w-3 h-3" />
                      {p.date}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <Clock className="w-3 h-3" />
                      {p.read}
                    </span>
                  </div>
                  <ArrowUpRight className="w-4 h-4 text-slate-950 group-hover:text-brand-gold group-hover:rotate-45 transition-all" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
